import App from "next/app";
import React, { Fragment } from "react";
import WithReduxStore from "../store/with-redux-store";
import { Provider } from "react-redux";
import NextNprogress from "nextjs-progressbar";

// Plugins CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";
import "rc-slider/assets/index.css";
import "react-intl-tel-input/dist/main.css";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css"; // youtube css file
// Custom css
import "./../public/assets/scss/style.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_ID } from "config";
import { ChatbotButton, syncChatbotVisibility } from "components/chatbot";
import { setToken } from "store/actions";
import { setUserInfo } from "store/actions/user";
import { get_cookie, get_user_info_storage } from "utils";

const CHATBOT_PAGES = ["home", "brand", "category", "vehicle"];

class MyApp extends App {
  /********************
  @purpose : Set NextJs Intial Data
  @Parameter : { Component, ctx }
  @Author : INIC
  ******************/
  static async getInitialProps({ Component, ctx }) {
    let pageProps = {};
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }
    return { pageProps };
  }
  state = {
    history: [],
    // loaded: false,
  };

  componentDidMount() {
    const { asPath } = this.props.router;
    this.setState((prevState) => ({ history: [...prevState.history, asPath] }));

    const { reduxStore } = this.props;
    if (get_cookie("token")) {
      const persistedUserInfo = get_user_info_storage();
      if (persistedUserInfo) {
        reduxStore.dispatch(setUserInfo(persistedUserInfo));
      }
    }
  }

  async componentWillMount() {
    const { reduxStore } = this.props;
    let token = get_cookie("token");
    token = token ? token : "";
    reduxStore.dispatch(setToken(token));
  }

  componentDidUpdate() {
    syncChatbotVisibility();

    const { history } = this.state;
    const { asPath } = this.props.router;

    // if current route (`asPath`) does not equal
    // the latest item in the history,
    // it is changed so lets save it
    if (history[history.length - 1] !== asPath) {
      this.setState((prevState) => ({
        history: [...prevState.history, asPath],
      }));
    }
  }

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  render() {
    const { Component, pageProps, reduxStore } = this.props;
    // const is_mobile_app = get_cookie("is_mobile_app");
    // const showSpinner = is_mobile_app === "yes" ? false : true;

    return (
      <Fragment>
        {/********************
        @purpose : Page Load Progress Bar
        @Author : INIC
        ********************/}

        <NextNprogress
          color="#1B73E7"
          startPosition={0.3}
          stopDelayMs={200}
          height="3"
          options={{
            easing: "ease",
            speed: 500,
            showSpinner: false,
          }}
        />
        <style jsx global>{`
          /* Ensure no other loader is shown */
          .nprogress-busy-indicator {
            display: none !important;
          }
        `}</style>

        {/********************
        @purpose : Connect Application With Redux
        @Author : INIC
        ********************/}
        <Provider store={reduxStore}>
          {/********************
          @purpose : Bind Application components
          @Author : INIC
          ********************/}
          <GoogleOAuthProvider clientId={GOOGLE_ID}>
            <Component history={this.state.history} {...pageProps} />
            {CHATBOT_PAGES.includes(pageProps?.currentPage) && (
              <ChatbotButton
                className={pageProps.currentPage === "home" ? "custom-chatbot-button--home" : ""}
              />
            )}
            {/* <ToastContainer /> */}
          </GoogleOAuthProvider>
        </Provider>
      </Fragment>
    );
  }
}
export default WithReduxStore(MyApp);
